<template>
  <b-input
    @input="$emit('input', buffer)"
    v-model="buffer"
    v-validate="'required'"
    expanded
  />
</template>

<script>
export default {
  name: 'DefaultInput',
  inject: ['$validator'],
  props: {
    value: Object
  },
  data () {
    return {
      buffer: this.value
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = this.value
      },
      deep: true
    }
  }
}
</script>
